<form [formGroup]="form">
    <h3 mat-dialog-title>{{data.title}}</h3>

    <mat-dialog-content class="small-content">
        <p class="mb-4">{{data.content}}</p>

        <ng-template #normalSelect>
            <mat-form-field class="w-100">
                <mat-select formControlName="selection" placeholder="{{data.selectionLabel}}">
                    <mat-option *ngFor="let selection of data.selections" [value]="selection">
                        {{selection.label}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-template>

        <ng-container *ngIf="data.useOutlineAppearance; else normalSelect">
            <mat-form-field appearance="outline" class="w-100 bg-white">
                <mat-select formControlName="selection" placeholder="{{data.selectionLabel}}">
                    <mat-option *ngFor="let selection of data.selections" [value]="selection">
                        {{selection.label}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>

        <strong *ngIf="data?.selectionWarning"
                class="d-block my-3 text-danger">{{data.selectionWarning(form.value.selection)}}</strong>

    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" class="btn btn-outline-secondary" mat-dialog-close>
            Cancel
        </button>
        <div>
            <button type="button" (click)="closeAndConfirm(true)" *ngIf="data.secondaryBtnContent" class="btn btn-outline-primary">{{data.secondaryBtnContent}}</button>
            <button type="submit" (click)="closeAndConfirm()" class="btn btn-primary">{{data.btnContent}}</button>
        </div>
    </mat-dialog-actions>
</form>
